var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"questions-page"},[(_vm.isLoading)?_c('div',{staticClass:"questions-page__loading"},[_c('load-indicator')],1):_vm._e(),_c('transition',{attrs:{"name":_vm.routerTransitionName,"mode":"out-in"}},[_c('router-view',{key:_vm.routerKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }